import React from "react";
import { useNavigate } from "react-router-dom";

export default function LoginPopup({ onClose, redirectUrl }) {
  const navigate = useNavigate();

  const handleOk = () => {
    onClose();
    if (redirectUrl) {
      navigate(redirectUrl);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div
        className="rounded-2xl shadow-xl p-6 w-80 text-center animate-fadeInScale"
        style={{
          backgroundColor: "#5E5ACF",
          color: "white",
        }}
      >
        <h2 className="text-lg font-semibold mb-4">
          Please login to use this service
        </h2>
        <div className="flex justify-center gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-white hover:bg-white hover:text-purple-700 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleOk}
            className="px-4 py-2 rounded-lg bg-white text-purple-700 font-bold hover:bg-gray-200 transition"
          >
            OK
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes fadeInScale {
            0% { opacity: 0; transform: scale(0.8); }
            100% { opacity: 1; transform: scale(1); }
          }
          .animate-fadeInScale {
            animation: fadeInScale 0.3s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
}
